module.exports = __webpack_public_path__ + "static/media/claw-marks.d8374e6a.svg";